var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-popover",
        {
          attrs: {
            placement: "left",
            width: _vm.boxWidth,
            trigger: _vm.popoverTrigger,
            "popper-class": "pd0",
          },
        },
        [
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.selectArray,
                border: "",
                size: "mini",
                "max-height": _vm.tableHeight,
                "header-cell-style": _vm.tableHeaderColor,
              },
            },
            [
              _vm.sortDisabled
                ? _c("el-table-column", {
                    attrs: {
                      label: "序号",
                      type: "index",
                      align: "center",
                      width: "50",
                    },
                  })
                : _vm._e(),
              _vm.imageDisabled
                ? _c("el-table-column", {
                    attrs: {
                      label: "图片",
                      type: "picJsonList",
                      "min-width": "100px",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.fileUrl
                                ? _c("el-image", {
                                    staticStyle: {
                                      width: "100px",
                                      height: "100px",
                                    },
                                    attrs: {
                                      src: scope.row.fileUrl,
                                      fit: "fill",
                                    },
                                  })
                                : scope.row.picJsonList
                                ? _c(
                                    "div",
                                    [
                                      scope.row.picJsonList.length > 0
                                        ? _c("popoverTipList", {
                                            ref: "myPopoverTipList",
                                            attrs: {
                                              popoverTrigger: "hover",
                                              labelValue: "id",
                                              tableType: "length",
                                              tableHeight: "500px",
                                              boxWidth: "200",
                                              imageDisabled: true,
                                              columns: [],
                                              selectArray:
                                                scope.row.picJsonList,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _c("span", [_vm._v("-")]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      219801
                    ),
                  })
                : _vm._e(),
              _vm._l(_vm.columns, function (column, index) {
                return [
                  _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      "header-align": "center",
                      align: "center",
                      "min-width": "100px",
                      label: column.label,
                    },
                  }),
                ]
              }),
            ],
            2
          ),
          _c(
            "el-button",
            { attrs: { slot: "reference", type: "text" }, slot: "reference" },
            [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.tableType == "text" ? _vm.name : _vm.selectArray.length
                  )
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }